var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5326 3.66992H3.19922V5.33659H16.5326V3.66992ZM16.5326 8.66992H3.19922V7.00326H16.5326V8.66992ZM9.03255 12.0033H3.19922V10.3366H9.03255V12.0033ZM10.0326 15.3366H3.19922V13.6699H10.0326V15.3366ZM13.0339 13.7109C13.0339 13.7109 11.6275 11.9109 10.8659 10.9397C10.6736 10.6922 10.8508 10.3359 11.1638 10.3359H16.4085C16.7214 10.3359 16.8986 10.6922 16.7063 10.9397C15.9447 11.9109 14.5421 13.7109 14.5421 13.7109V15.9609C14.5421 16.1672 14.3724 16.3359 14.1651 16.3359H13.411C13.2036 16.3359 13.0339 16.1672 13.0339 15.9609V13.7109Z",
    fill: "#3F51B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterTemplate);
export default __webpack_public_path__ + "static/media/filter_template.db392db1e961036fa8f6021f3f58b381.svg";
export { ForwardRef as ReactComponent };